export default "__VITE_ASSET__f05ab114__"